import { createActionGroup } from '@ngrx/store';

export const SocieteConfigAnalyseSyntheseSocieteCaracteristiqueActions = createActionGroup({
  source: 'Societe Config Analyse Synthese Societe Caracteristique',
  events: {}
});
